<template>
  <div id="app">
    <router-view v-if="isRouter"></router-view>
  </div>
</template>
<script>
import { dictAll, industryTree } from "./api/index";
export default {
  name: "App",
  provide(){
    return {
      reload:this.reload
    }
  },
  data() {
    return {
        isRouter:true,
    }
  },
  created() {
    // 获取字段表---金额区间
    this.getDict();
    this.getSalaryInterval();
    // if (!localStorage.getItem("priceList")) {
    //   this.getSalaryInterval();
    // }

    // 判断进来时的身份（只执行一次）
    if (!localStorage.getItem("once") && window.localStorage.getItem("poepleType")) {
      if (window.localStorage.getItem("poepleType") == 2&&JSON.parse(localStorage.getItem("detailInfo")).companyAuth==9) {
        this.$router.push("/mainPrise/staging");
      }
      localStorage.setItem("once", 1);
    }
  },
  methods: {
    // 刷新页面（优化版本的reload）
    reload(){
      this.isRouter = false;
      this.$nextTick(function(){
        this.isRouter = true
      })
    },
    // 获取薪资区间结构
    getSalaryInterval() {
      let leftArr = [{ value: "面议", id: 0 }];
      let rightArr = [];
      const leftMaxNumber = 250;
      const rightMaxNumber = 260;
      let IncrementalNumber = 1;
      for (var i = 1; i <= leftMaxNumber; i++) {
        if (i < 30) {
          leftArr.push({ value: i + "K", id: 0 });
        }
        if (i >= 30 && i < 100) {
          IncrementalNumber = 4;
          leftArr.push({ value: i + "K", id: 0 });
          i = i + IncrementalNumber;
        }
        if (i >= 100 && i <= leftMaxNumber) {
          IncrementalNumber = 9;
          leftArr.push({ value: i + "K", id: 0 });
          i = i + IncrementalNumber;
        }
      }
      for (var i = 1; i <= rightMaxNumber; i++) {
        if (i < 30) {
          rightArr.push({ value: i + "K", id: 0 });
        }
        if (i >= 30 && i < 100) {
          IncrementalNumber = 4;
          rightArr.push({ value: i + "K", id: 0 });
          i = i + IncrementalNumber;
        }
        if (i >= 100 && i <= rightMaxNumber) {
          IncrementalNumber = 9;
          rightArr.push({ value: i + "K", id: 0 });
          i = i + IncrementalNumber;
        }
      }
      localStorage.setItem("priceList", JSON.stringify([leftArr, rightArr]));
    },
// 去除空children
 deleteChildren(arr,type) {
     let childs = arr
     for (let i = childs.length; i--; i > 0) {
       if (childs[i].children) {
         if (childs[i].children.length) {
           this.deleteChildren(childs[i].children,type)
         } else {
           delete childs[i].children
         }
       }
     }
     if(type=="yesLimit"){  // 有不限
      localStorage.setItem("industryListYesLimit", JSON.stringify(arr));
     }else{  // 没有不限
      localStorage.setItem("industryList", JSON.stringify(arr));
     }
   },
    // 获取字典
    getDict() {
      // 1： 求职状态
      // 2： 求职类型
      // 3： 专业
      // 4： 学历
      // 5： 经验要求区间
      // 6： 人数规模区间
      // 7： 年龄区间
      // 8： 学历区间
      // 9： 政治面貌
      // 10：融资阶段
      // 11：招聘类型
      // 12：薪资区间
      // 13：证书要求
      // 26 ：标记状态
      // if (!localStorage.getItem("dictList") || JSON.parse(localStorage.getItem("dictList")).code) {
        dictAll().then(res => {
          localStorage.setItem("dictList", JSON.stringify(res.data.data));
        });
      // }
      // 期望职位列表
      // if (!localStorage.getItem("industryList")) {
        industryTree().then(res => {
          var data1 = JSON.parse(JSON.stringify(res.data.data));
          var data2 = JSON.parse(JSON.stringify(res.data.data));
          data1.forEach(item=>{
            item.children.unshift({name:"不限",id:item.id})
            item.children.forEach(itemC=>{
              if(itemC.children){
                itemC.children.unshift({name:"不限",id:itemC.id})
              }
            })
          })
          this.deleteChildren(data1,'yesLimit')
          this.deleteChildren(data2,'noLimit')
        });
      // }
    }
  }
};
</script>

<style>

@import "style/my.css";
/* body { */
  /* !*禁止文字被选中*! */
  /* -moz-user-select: none; */
  /* !*火狐*! */
  /* -webkit-user-select: none; */
  /* !*webkit浏览器*! */
  /* -ms-user-select: none; */
  /* !*IE10*! */
  /* -khtml-user-select: none; */
  /* !*早期浏览器*! */
  /* user-select: none; */
/* } */
#mapBox{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue